import type { DeprecatedButtonTokens } from '../types';

export const deprecatedButton: DeprecatedButtonTokens = {
  colors: {
    darkButtonTextColor: 'neutral.90',
    lightButtonBgColor: 'secondary.50',
  },
};
